import { notifySimple } from "providers/toast";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setLoading } from "store/appSlice";
import GenericDialog from "./generic";
import axios from "axios";
import GenericButton from "widgets/controls/buttons/generic";

const SwitchContactorDialog = (props: {
  isOpen: boolean;
  onClose: (refresh: boolean) => void;
  onSuccess: (refresh: boolean) => void;
  selected: any;
}) => {
  const { isOpen, onClose, onSuccess, selected } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();

  // Function for linking a user
  const doSwitchContactor = async (state: "OPEN" | "CLOSE") => {
    dispatch(setLoading(true));

    try {
      const response = await axios.post(
        "https://api.in4mgroup.com:3011/lora/downlink/tts/opt/batchcontrol/meter",
        {
          serialNumber: selected.meterNumber,
          action: state,
        },
        {
          headers: {
            "api-key":
              "50461f781478c1d30dbe77a47795f0ade57e832c57062a174bbc97c7366d9337",
            "Content-Type": "application/json",
          },
        }
      );

      dispatch(setLoading(false));

      if (response.status === 200) {
        onSuccess(true);
        notifySimple(t("notification.switch.contactor.success"), "success");
      } else {
        onSuccess(false);
        notifySimple(t("notification.switch.contactor.error"), "error");
      }
    } catch (error: any) {
      dispatch(setLoading(false));
      onSuccess(false);
      notifySimple(t("notification.switch.contactor.error"), "error");
    }
  };

  return (
    <GenericDialog
      isOpen={isOpen}
      title={t("dialog.switch.contactor.title")}
      onExit={() => onClose(false)}
      size="lg"
    >
      <div className="-mt-6 flex flex-col gap-4">
        <div className="text-txt-md font-medium text-secondary">
          {t("dialog.switch.contactor.description")}
        </div>

        <div className="flex gap-2">
          <GenericButton
            onClick={() => doSwitchContactor("CLOSE")}
            text={t("button.action.close.contactor")}
            size="md"
            color="secondary"
            variant="outline"
            extra="flex-1"
          />

          <GenericButton
            onClick={() => doSwitchContactor("OPEN")}
            text={t("button.action.open.contactor")}
            size="md"
            color="tertiary"
            extra="flex-1"
          />
        </div>
      </div>
    </GenericDialog>
  );
};

export default SwitchContactorDialog;
